import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { ILifeEvent, LifeEvent } from '../LifeEvent.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { LifeEventsApi } from '../../../apis/LifeEventsApi/LifeEventsApi.ts';

export function useGetLifeEvents(patientId: string | undefined) {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.lifeEvents, patientId],
        queryFn: async () => {
            const result: ILifeEvent[] = await LifeEventsApi.getLifeEvents(patientId!);
            return result ? result.map((x) => new LifeEvent(x)) : (result ?? []);
        },
        enabled: !!patientId,
    });
}
